module.exports = __webpack_public_path__ + "static/media/Loans.528b15ac.svg";